import { render, staticRenderFns } from "./current-element.vue?vue&type=template&id=5bcc3f61&scoped=true"
import script from "./current-element.vue?vue&type=script&lang=ts"
export * from "./current-element.vue?vue&type=script&lang=ts"
import style0 from "./current-element.vue?vue&type=style&index=0&id=5bcc3f61&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bcc3f61",
  null
  
)

export default component.exports